import EtgFaresContainer from './containers/EtgFaresContainer';
const name = 'etgFares';
const id = 'etg-fares';
export const etgFares = {
  formSection: name,
  id,
  name
};
export default EtgFaresContainer;
//# sourceMappingURL=index.js.map